import React from 'react';
import { InboxIcon } from '@heroicons/react/24/outline';

const EmptyState = ({
  icon: Icon = InboxIcon,
  title = 'No data found',
  message = 'There are no items to display at the moment.',
  action,
}) => {
  return (
    <div className="empty-state py-16">
      <div className="empty-state-icon">
        <Icon className="w-10 h-10 text-slate-400" />
      </div>
      <h3 className="text-lg font-semibold text-slate-800 mb-2">{title}</h3>
      <p className="text-slate-500 mb-6 max-w-sm mx-auto">{message}</p>
      {action && <div>{action}</div>}
    </div>
  );
};

export default EmptyState;
